import React, { useRef, useState } from "react";
import "./style.scss";
import PlayIcon from "../SvgIcons/PlayIcon";

export default function Video() {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const togglePlayPause = () => {
    if (playing) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setPlaying(!playing);
  };

  return (
    <section className="video-main" data-aos="fade-in">
      <div className="container">
        <div className="video-box">
          <video
            poster="../images/video-thumbnail.png"
            ref={videoRef}
            controls={playing}
            src="../images/PathsLifesRide.mp4"
          />
          {!playing && (
            <div className="controls">
              <div className="play-pause" onClick={togglePlayPause}>
                <PlayIcon />
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
